// Styles
import './product-recommendations.scss';
import Cookies from 'js-cookie';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductRecommendations = (context) => {

  const productRecommendationsSection = context.closest('.shopify-section');
  if (!productRecommendationsSection) return;

  if (typeof (window.dAgency.initProductTile) !== 'undefined') {
    const productTiles = productRecommendationsSection.querySelectorAll('.product-tile__container');
    if (productTiles.length > 0) {
      productTiles.forEach(tile => {
        window.dAgency.initProductTile(tile);
      });
    }
  }

  function waitForProducts(container, selector) {
    return new Promise(resolve => {
      if (container.querySelector(selector)) {
        return resolve(container.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
        if (container.querySelector(selector)) {
          resolve(container.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(container, {
        subtree: true,
        childList: true,
      });
    });
  }

  const initializeContents = () => {
    const slider = productRecommendationsSection.querySelector('[data-products-carousel-master]');

    if (slider) {
      new Swiper(slider, {
        slidesPerView: 1.8,
        spaceBetween: 4,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          snapOnRelease: true
        },
        breakpoints: {
          768: {
            slidesPerView: 2.3,
          },
          1024: {
            slidesPerView: 4.2,
          }
        }
      });
    }

    const tabs = productRecommendationsSection.querySelectorAll('.tabs__container .tab');
    const panels = productRecommendationsSection.querySelectorAll('.tabs__container .panel');

    if (tabs.length) {

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(tab => {
            tab.classList.remove('active');
          })
          tab.classList.add('active');

          const target = '#' + tab.getAttribute('for');
          const activePanel = productRecommendationsSection.querySelector(target);
          panels.forEach(panel => {
            panel.classList.remove('active');
          })
          activePanel.classList.add('active');
        });
      });
    }

    if (window.dAgency.proxyLinkSetup) window.dAgency.proxyLinkSetup(productRecommendationsSection);

  }

  waitForProducts(productRecommendationsSection ,'.product-recommendations__wrapper').then(element => {
    initializeContents();
  });

  //Recently viewed section
  if (document.cookie.indexOf('RECENTLY_VIEWED') != -1) {
    var products_cookie = Cookies.get('RECENTLY_VIEWED').split(',');
    var search_q_partial = products_cookie.map(function (product) {
      if (product) {
        return 'handle:"' + product + '"';
      }
    });

    var search_query = window.Shopify.routes.root + 'search?q=' + search_q_partial.join('+OR+') + '&type=product';

    fetch(window.location.origin + search_query)
      .then(function (response) {
        if (response.ok) {
          return response.text();
        }
        throw new Error('Something went wrong:' + response.status + '-' + response.statusText);
      })
      .then(function (html) {
        var html_parsed = new DOMParser().parseFromString(html, 'text/html');
        var products = html_parsed.getElementById('AjaxinateContainer').innerHTML;

        document.getElementById('recently-viewed-wrapper').innerHTML = products;
        var productsItems = document.getElementById('recently-viewed').querySelectorAll('.search__products__element')

        if (productsItems.length > 1) {

          initializeContents();

          productsItems.forEach(item => {
            item.classList.add('swiper-slide')
          });

          const viewedTab = document.getElementById('tab-viewed')

          if (viewedTab) {
            viewedTab.style.display = 'block';
          }

          const sliderRecently = document.getElementById('recently-viewed');

          if (sliderRecently) {
            new Swiper(sliderRecently, {
              slidesPerView: 1.8,
              spaceBetween: 4,
              scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
                snapOnRelease: true
              },
              breakpoints: {
                768: {
                  slidesPerView: 2.3,
                },
                1024: {
                  slidesPerView: 4.2,
                }
              }
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-recommendations__section'), (el) => {
    window.dAgency.initProductRecommendations(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-recommendations__section'), (el) => {
      window.dAgency.initProductRecommendations(el);
    });
  });
}
